import React from "react";
import { Container, Spinner } from "react-bootstrap";
import { user_token } from "../../../_helpers/tokensStored";
import useHiringManagerOnboard from "./useHiringManagerOnboard";
import { Carousel } from "antd";
import { TimezoneSearchInput } from "../../../_uiComponents/Search/TimezoneSearchInput";

export default (props) => {
  const user = user_token;
  const { loading, onNextClick, onInputChange, formInputsError, onSignOut , onTimeZoneChange} = 
    useHiringManagerOnboard();
  return (
    <div className="common-login role-selection-wrapper">
      <Container className="px-0">
        <div className="row no-gutters">
        <div className="col-lg-6 d-none d-md-block">
          <div className="left-img h-100 bg-primary">
            <div className="login-slider">
              <Carousel autoplay arrows>
                <div className="slider-content">
                  <img
                    src="/assets/images/slider-img-1.svg"
                    alt="slider-img"
                    className="slider-img"
                  />
                  <h2 className="text-white mb-2">
                    Simplify Your Recruitment Process
                  </h2>
                  <p className="font-weight-medium text-white">
                    Make recruitment easy for businesses of all sizes.
                    Streamline your hiring process, from job posting to
                    candidate management, and discover the best-fit candidates
                    for your team with Jigsaw's innovative platform.
                  </p>
                </div>
                <div className="slider-content">
                  <img
                    src="/assets/images/slider-img-2.svg"
                    alt="slider-img"
                    className="slider-img"
                  />
                  <h2 className="text-white mb-2">
                    Rescue Hiring Manger & Candidate From Fate
                  </h2>
                  <p className="font-weight-medium text-white">
                    Don't leave recruitment process of hiring manager and
                    candidate’s career to fate. Take control with Jigsaw's
                    intuitive platform, designed to simplify recruitment and
                    elevate your professional growth. Say goodbye to uncertainty
                    and achieve your goals with Jigsaw.
                  </p>
                </div>
                <div className="slider-content">
                  <img
                    src="/assets/images/slider-img-3.svg"
                    alt="slider-img"
                    className="slider-img"
                  />
                  <h2 className="text-white mb-2">
                    Take Control of Your Career with Jigsaw!
                  </h2>
                  <p className="font-weight-medium text-white">
                    Unlock your full potential and achieve your career goals
                    with Jigsaw. Our intuitive platform empowers you with the
                    tools and resources you need to succeed, streamlined job
                    searching and interview preparation. Take control of your
                    future today with Jigsaw.
                  </p>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
          <div className="col-lg-6 ">
            <div className="form-wrapper py-5 h-100">
              <ul className="steps d-flex align-items-center justify-content-between mx-auto mb-4">
                <li className="step completed">
                  <span>1</span>
                </li>
                <li className="step completed">
                  <span>2</span>
                </li>
                <li className="step">
                  <span>3</span>
                </li>
              </ul>
              <h1 className="mb-2">Get Started!</h1>
              <div className="form-group">
                  <p className="font-weight-medium">Time Zone</p>
                  <TimezoneSearchInput
                    className="form-control"
                    placeholder="Search Timezone..."
                    onSearchSelect={(item) =>
                      onTimeZoneChange({
                        target: {
                          value: item, 
                          name: "timezone",
                        },
                      })
                    }
                    clearSearch={false}
                    defaultTimezoneValue={
                      user?.user_details?.timezone
                    }
                  />
                </div>
              <div className="form-group">
                <label htmlFor="" className="mb-2 font-weight-medium">
                  Company Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Company Name"
                  onChange={(e) => onInputChange(e.target.value, "name")}
                  defaultValue={
                    user_token?.user &&
                    user_token.user?.user_meta_info &&
                    user_token.user.user_meta_info.company_details?.name
                  }
                  disabled={
                    user_token?.user &&
                    user_token.user?.user_meta_info &&
                    user_token.user.user_meta_info.company_details?.name !== ""
                  }
                />
                {formInputsError.name && formInputsError.name.length > 0 ? (
                  <span className="text-danger mt-1">
                    {formInputsError.name}
                  </span>
                ) : null}
              </div>
              <div className="form-group">
                <label htmlFor="" className="mb-2 font-weight-medium">
                  Company Domain
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Company Domain"
                  onChange={(e) => onInputChange(e.target.value, "url")}
                  defaultValue={
                    user_token?.user &&
                    user_token.user?.user_meta_info &&
                    user_token.user.user_meta_info.company_details?.url
                  }
                  disabled={
                    user_token?.user &&
                    user_token.user?.user_meta_info &&
                    user_token.user.user_meta_info.company_details?.url !== ""
                  }
                />
                {formInputsError.url && formInputsError.url.length > 0 ? (
                  <span className="text-danger mt-1">
                    {formInputsError.url}
                  </span>
                ) : null}
              </div>

              <div className="form-group">
                <label htmlFor="" className="mb-2 font-weight-medium">
                  Size
                </label>
                <span className="select">
                  <select
                    name=""
                    id=""
                    className="form-control"
                    onChange={(e) => onInputChange(e.target.value, "size")}
                    defaultValue={
                      user_token?.user &&
                      user_token.user?.user_meta_info &&
                      user_token.user.user_meta_info.company_details?.size
                    }
                    disabled={
                      user_token?.user &&
                      user_token.user?.user_meta_info &&
                      user_token.user.user_meta_info.company_details?.size !==
                      null
                    }
                  >
                    <option value="Select Company Size" defaultValue="">
                      Select Company Size
                    </option>
                    <option value="1-10">1-10</option>
                    <option value="11-50">11-50</option>
                    <option value="51-200">51-200</option>
                  </select>
                </span>

                {formInputsError.size && formInputsError.size.length > 0 ? (
                  <span className="text-danger mt-1">
                    {formInputsError.size}
                  </span>
                ) : null}
              </div>

              <div className="form-group">
                <label htmlFor="" className="mb-2 font-weight-medium">
                  Industry
                </label>
                <span className="select">
                  <select
                    name=""
                    id=""
                    className="form-control"
                    onChange={(e) => onInputChange(e.target.value, "industry")}
                    defaultValue={
                      user_token?.user &&
                      user_token.user?.user_meta_info &&
                      user_token.user.user_meta_info.company_details?.industry
                    }
                    disabled={
                      user_token?.user &&
                      user_token.user?.user_meta_info &&
                      user_token.user.user_meta_info.company_details
                        ?.industry !== ""
                    }
                  >
                    <option value="Select Industry Type" defaultValue="">
                      Select Industry Type
                    </option>
                    <option value="IT">IT</option>
                    <option value="Networking">Networking</option>
                    <option value="Other">Other</option>
                  </select>
                </span>
                {formInputsError.industry &&
                  formInputsError.industry.length > 0 ? (
                  <span className="text-danger mt-1">
                    {formInputsError.industry}
                  </span>
                ) : null}
              </div>
              {user_token?.user.user_meta_info && user_token.user.user_meta_info.company !== null ? (
                <span className="text-danger mt-1">
                  You have already joined with a company.
                </span>
              ) : null}
              {formInputsError.formSubmitError &&
                  formInputsError.formSubmitError.length > 0 ? (
                  <span className="text-danger mt-1">
                    {formInputsError.formSubmitError}
                  </span>
                ) : null}
              <div className="mt-auto py-4">
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    onNextClick();
                  }}
                >
                  {loading ? (
                    <Spinner animation="border" variant="" className="text-white" />
                  ) : (
                    "Next"
                  )}
                </button>
              </div>
              <div className="d-flex align-items-center  mt-auto py-4 justify-content-center">
                <p className="text-center mt-3">
                  Go back to website{" "}
                  <span className="text-primary text-underline cursor-pointer" onClick={onSignOut}>
                    {" "}
                    JIGSAW.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
